export enum ShowCaseViewType {
    'showcase' = 0,
    'landing' = 1
}

export enum ShowCaseTitleType {
    'text' = 0,
    'link' = 1
}

export enum ShowCaseFilterType {
    'showcase' = 0,
    'sections' = 1
}

export enum ShowCaseViewType {
    'showcase' = 0,
    'landing' = 1
}

export enum ShowCaseTitleType {
    'text' = 0,
    'link' = 1
}

export enum ShowCaseFilterType {
    'showcase' = 0,
    'sections' = 1
}

